export default __webpack_public_path__ + "8bdd55746ec0781dc4f4b9974680a9e1.png";